import React from 'react'
import { Route, Routes } from 'react-router'
import AdminLandingPage from '../app/landing/pages/AdminLandingPage'
import TenderDashboardPage from '../app/admin/erp/crm/tender/pages/TenderDashboardPage'
import TenderDetailsPage from '../app/admin/erp/crm/tender/pages/TenderDetailsPage'
import GrievanceDashboardPage from '../app/admin/erp/crm/grievance/pages/GrievanceDashboardPage'
import GrievanceDetailsPage from '../app/admin/erp/crm/grievance/pages/GrievanceDetailsPage'
import CustomerListPage from '../app/admin/erp/crm/customer/pages/CustomerListPage'
import LeadDashboardPage from '../app/admin/erp/crm/lead/pages/LeadDashboardPage'
import LeadListPage from '../app/admin/erp/crm/lead/pages/LeadListPage'
import ProposalListPage from '../app/admin/erp/crm/proposal/pages/ProposalListPage'
import ProposalDetailsPage from '../app/admin/erp/crm/proposal/pages/ProposalDetailsPage'
import CRMTermsTemplateListPage from '../app/admin/erp/crm/termsTemplate/pages/CRMTermsTemplateListPage'
import DocumentTemplateListPage from '../app/admin/erp/crm/documentTemplate/pages/DocumentTemplateListPage'
import DocumentTemplateDetailsPage from '../app/admin/erp/crm/documentTemplate/pages/DocumentTemplateDetailsPage'




function CrmRoutes() {
  return (
    <>
      <Routes>
        
        {/* CRM Pages */}
        <Route path="/tender/dashboard" element={<TenderDashboardPage /> }></Route>
        <Route path="/tender/details/:id" element={<TenderDetailsPage /> }></Route>
        <Route path="/grievance/dashboard" element={<GrievanceDashboardPage /> }></Route>
        <Route path="/grievance/details/:id" element={<GrievanceDetailsPage /> }></Route>

        <Route path="/customer/list" element={<CustomerListPage /> }></Route>


        <Route path="/lead/dashboard" element={<LeadDashboardPage /> }></Route>
        <Route path="/lead/list" element={<LeadListPage /> }></Route>

        <Route path="/proposal/list" element={<ProposalListPage /> }></Route>
        <Route path="/proposal/details/:id" element={<ProposalDetailsPage /> }></Route>

        <Route path="/crm/terms-template" element={<CRMTermsTemplateListPage /> }></Route>
        <Route path="/crm/document-template" element={<DocumentTemplateListPage /> }></Route>
        <Route path="/crm/document-template/details/:id" element={<DocumentTemplateDetailsPage /> }></Route>
      </Routes>
      
    </>
  )
}

export default CrmRoutes